const getHotelsBySearchTags = (hotelsOrPillar, pillar) => {
  // Guard: Return empty array if hotelsOrPillar is undefined, null, or not an array
  if (!hotelsOrPillar || !Array.isArray(hotelsOrPillar) || hotelsOrPillar.length === 0) {
    return [];
  }
  
  // Guard: Return empty array if pillar is undefined or missing required properties
  if (!pillar || !pillar.hotelSearchOptions) {
    return [];
  }
  // Filter by Search Tags
  // All Search tag options
  const filterByTags = pillar.hotelSearchTags
    ? Object.values(pillar.hotelSearchTags.filterByTags)
    : null;
  const {
    filterByCountry,
    filterByCounty,
    filterByTown,
    filterByCountyOrTown,
    filterByAnySearchTags,
  } = pillar.hotelSearchOptions;

  // Search option variable
  let tagFilteredResults = [],
    countryFilteredResults = [],
    countyFilteredResults = [],
    townFilteredResults = [];

  // All filtered hotel arrays will go in here
  let allFilteredResults = [];

  // -> REUSABLE FUNCTIONS
  // Check array to see if value appears and return results
  function filterByValue(array, string) {
    return array.filter((obj) => obj?.toLowerCase() === string?.toLowerCase());
  }

  // -> OPTION 1: FILTER BY SEARCH TAGS / LOCATION TEXT FIELDS
  const hotelSearchOptions = (hotel) => {
    let filteredTagsArr = [];
    hotel?.hotelInformation?.searchTags.forEach((item, index) => {
      if (filteredTagsArr.length === 0) {
        filteredTagsArr.push(item);
      } else {
        let tagExists = false;
        filteredTagsArr.forEach((tag) => {
          if (tag.value === item.value) {
            tagExists = true;
          }
        });
        if (!tagExists) {
          filteredTagsArr.push(item);
        }
      }
    });
    /* hotel.hotelInformation?.searchTags = filteredTagsArr; */

    // -> 1. Filter BySearchTags
    // console.log({hotel, filterByTags})
    if (filterByTags && filterByTags.length) {
      // Get tag values and store in an array so it's easier to comapre
      const tagsToFind = filterByTags.map((tag) => tag.value);
      // an array of search tag objects the hotel has
      const hotelTagsToSearch = hotel?.hotelInformation?.searchTags;
      // Filter through both arrays and only push hotels that have any matches
      let filteredHotelsByTags = [];
      tagsToFind.forEach((tag) => {
        hotelTagsToSearch?.forEach((item) => {
          // remove any tags that are null - check from old content import
          if (item !== null) {
            if (
              item.value.toLowerCase().replace(/\s/g, "") === tag.toLowerCase()
            ) {
              filteredHotelsByTags.push(
                item.value.toLowerCase().replace(/\s/g, "")
              );
            }
          }
        });
      });
      // If filterByAnySearchTags is true then we can search for any tags that feature, not all (if there's duplicates we will remove them at the end when we have allFilteredResults)
      if (filterByAnySearchTags) {
        if (filteredHotelsByTags.length > 0) {
          tagFilteredResults.push(hotel._id);
        }
      }
      // Then we check our new hotel matches array equals the tagsToFind array length (ensures all tags)
      else if (filteredHotelsByTags.length === tagsToFind.length) {
        // Push this hotel to mainArray to move on and check next criteria
        tagFilteredResults.push(hotel._id);
      } else if (
        filteredHotelsByTags.length > 0 &&
        filteredHotelsByTags.includes(tagsToFind[0]) &&
        // ||
        filteredHotelsByTags.filter((tag) =>
          tagsToFind.slice(1, tagsToFind.length).includes(tag)
        ).length > 0
      ) {
        tagFilteredResults.push(hotel._id);
      }
    }

    // -> 2. Filter By Country
    if (filterByCountry.length) {
      const hotelCountry = hotel?.addressGroup?.country;
      // loop through countries array and find matches
      const filterCountries = filterByValue(filterByCountry, hotelCountry);
      if (filterCountries.length) {
        // If country matches, push id to array
        countryFilteredResults.push(hotel._id);
      }
    }

    // -> 3. Filter By County
    if (filterByCounty) {
      const hotelCounty = hotel?.addressGroup?.county;
      // Split into array in case there are multiple counties
      let filterByCountyArr = filterByCounty.split(",");
      // Filter through county array and only push hotels that have any matches
      let filterCounties = [];
      filterByCountyArr.forEach((item) => {
        if (item.toLowerCase().trim() === hotelCounty?.toLowerCase().trim()) {
          filterCounties.push(item.value);
        }
      });
      // If there are any results in filterCounties push this through to countyFilteredResults
      if (filterCounties.length) {
        countyFilteredResults.push(hotel._id);
      }
    }

    // -> 4. Filter By Town
    if (filterByTown) {
      // If town matches, push to array
      const hotelTown = hotel?.addressGroup?.town;

      // Split into array in case there are multiple counties
      let filterByTownArr = filterByTown.split(",");
      // Filter through county array and only push hotels that have any matches
      let filterTowns = [];
      filterByTownArr.forEach((town) => {
        if (town.toLowerCase().trim() === hotelTown?.toLowerCase().trim()) {
          filterTowns.push(town.value);
        }
      });
      // If there are any results in filterCounties push this through to countyFilteredResults
      if (filterTowns.length) {
        townFilteredResults.push(hotel._id);
      }
    }
  };

  const pageSearchOptions = (pillar) => {
    // If pagetype is country only search country
    // If pagetype is county only search county
    // If pagetype is town / city only search town / city
    // If pagetype is region only search region

    // 		// -> 1. Filter BySearchTags

    //     //  JUST CHECK THAT FIELDS ARE THE SAME?  IF SO PUSH TO ARRAY

    // 		if (filterByTags.length) {
    //       // Get tag values and store in an array so it's easier to comapre
    // 			const tagsToFind = filterByTags.map((tag) => tag.value);
    // 			// an array of search tag objects the hotel has
    // 			const pillarTagsToSearch = pillar.hotelSearchTags ? Object.values(pillar.hotelSearchTags.filterByTags) : null;

    //       if(pillarTagsToSearch) {
    // // Filter through both arrays and only push hotels that have any matches
    //         let filteredPillarsByTags = [];
    //         tagsToFind.forEach((tag) => {
    //           pillarTagsToSearch.forEach((item) => {
    //             if (item.value === tag) {
    //               filteredPillarsByTags.push(item.value);
    //             }
    //           });
    //         });
    //         // If filterByAnySearchTags is true then we can search for any tags that feature, not all (if there's duplicates we will remove them at the end when we have allFilteredPillars)
    //         if (filteredPillarsByTags.length > 0) {
    //           tagFilteredResults.push(pillar._id);
    //         }
    //         // Then we check our new pillar matches array equals the tagsToFind array length (ensures all tags)
    //         else if (filteredPillarsByTags.length === tagsToFind.length) {
    //           // Push this hotel to mainArray to move on and check next criteria
    //           tagFilteredResults.push(pillar._id);
    //         }
    //       }
    // 		}
    // console.log({tagFilteredResults})

    if (filterByTags) {
      // console.log({ pillar });
      const tagsToFind = filterByTags.map((tag) => tag.value);
      const pillarTagsToSearch = pillar.hotelSearchTags
        ? Object.values(pillar.hotelSearchTags.filterByTags)
        : null;
      // console.log('🌍', { filterByTags }, { pillarTagsToSearch });
      // Split into array in case there are multiple counties

      if (pillarTagsToSearch) {
        // Filter through both arrays and only push pages that have any matches
        let filteredHotelsByTags = [];
        tagsToFind.forEach((tag) => {
          pillarTagsToSearch.forEach((item) => {
            if (item.value === tag) {
              filteredHotelsByTags.push(item.value);
            }
          });
        });
        // Filter through both arrays and only push hotels that have any matches
        let filteredPillarsByTags = [];
        tagsToFind.forEach((tag) => {
          pillarTagsToSearch.forEach((item) => {
            if (item.value === tag) {
              filteredPillarsByTags.push(item.value);
            }
          });
        });

        if (filteredHotelsByTags.length > 0) {
          tagFilteredResults.push(pillar._id);
        }
      }

      // // Filter through country array and only push pillars that have any matches
      // let filterTags = [];
      // if (pillarTagsToSearch) {
      // 	// // change to lowercase & remove spaces for each item in arrays
      // 	// pillarTagsToSearch.map((item) => (item = item.toLowerCase().trim()));
      // 	// filterByTags.map((item) => (item = item.toLowerCase().trim()));

      // 	if (
      // 		filterByTags.some((pillarItem) =>
      // 			pillarTagsToSearch.includes(pillarItem)
      // 		)
      // 	) {
      // 		filterTags.push(filterByTags.value);
      // 	}
      // 	// });
      // }
      // // If there are any results in filterByTags push this through to countryFilteredResults
      // if (filterTags.length) {
      // 	tagFilteredResults.push(pillar._id);
      // }
    }

    // console.log('🍞 🍞 🍞 🍞 ', { tagFilteredResults });

    // -> 2. Filter By Country
    if (filterByCountry) {
      const pillarCountry = pillar.hotelSearchOptions.filterByCountry
        ? pillar.hotelSearchOptions.filterByCountry
        : null;

      // console.log('🌍', filterByCountry, pillarCountry);
      // Split into array in case there are multiple counties

      // Filter through country array and only push pillars that have any matches
      let filterCountries = [];
      if (pillarCountry) {
        // change to lowercase & remove spaces for each item in arrays
        pillarCountry.map((item) => (item = item.toLowerCase().trim()));
        filterByCountry.map((item) => (item = item.toLowerCase().trim()));

        // filterByCountry.forEach((item) => {
        // console.log({item})
        if (
          filterByCountry.some((pillarItem) =>
            pillarCountry.includes(pillarItem)
          )
        ) {
          filterCountries.push(filterByCountry.value);
        }
        // });
      }
      // If there are any results in filterCounties push this through to countryFilteredResults
      if (filterCountries.length) {
        countryFilteredResults.push(pillar._id);
      }
    }

    // console.log('🍞 🍞 🍞 🍞 ', { countryFilteredResults });

    // -> 3. Filter By County
    if (filterByCounty) {
      const pillarCounty = pillar.hotelSearchOptions.filterByCounty
        ? pillar.hotelSearchOptions.filterByCounty.split(",")
        : null;

      // console.log('🌍', filterByCounty, pillarCounty);
      // Split into array in case there are multiple counties
      let filterByCountyArr = filterByCounty.split(",");

      // Filter through county array and only push pillars that have any matches
      let filterCounties = [];
      if (pillarCounty) {
        // change to lowercase & remove spaces for each item in arrays
        pillarCounty.map((item) => (item = item.toLowerCase().trim()));
        filterByCountyArr.map((item) => (item = item.toLowerCase().trim()));

        // filterByCountyArr.forEach((item) => {
        // console.log({item})
        if (
          filterByCountyArr.some((pillarItem) =>
            pillarCounty.includes(pillarItem)
          )
        ) {
          filterCounties.push(filterByCountyArr.value);
        }
        // });
      }
      // If there are any results in filterCounties push this through to countyFilteredResults
      if (filterCounties.length) {
        countyFilteredResults.push(pillar._id);
      }
    }

    // console.log('🍞 🍞 🍞 🍞 ', { countyFilteredResults });

    // -> 4. Filter By Town
    // if (filterByTown) {
    // 	// console.log({filterByTown});
    // 	// If town matches, push to array
    // 	const hotelTown = hotel.addressGroup.town;
    // 	// if (hotelTown.toLowerCase() === filterByTown.toLowerCase()) {
    // 	// 	townFilteredResults.push(hotel._id);
    // 	// }

    // 	// Split into array in case there are multiple counties
    // 	let filterByTownArr = filterByTown.split(',');
    // 	// Filter through county array and only push hotels that have any matches
    // 	let filterTowns = [];
    // 	filterByTownArr.forEach((town) => {
    // 		if (town.toLowerCase().trim() === hotelTown.toLowerCase().trim()) {
    // 			filterTowns.push(town.value);
    // 		}
    // 	});
    // 	// If there are any results in filterCounties push this through to countyFilteredResults
    // 	if (filterTowns.length) {
    // 		townFilteredResults.push(hotel._id);
    // 	}
    // }

    if (filterByTown) {
      const pillarTown = pillar.hotelSearchOptions.filterByTown
        ? pillar.hotelSearchOptions.filterByTown.split(",")
        : null;

      // console.log('🌍', filterByTown, pillarTown);
      // Split into array in case there are multiple counties
      let filterByTownArr = filterByTown.split(",");

      // Filter through county array and only push pillars that have any matches
      let filterTowns = [];
      if (pillarTown) {
        // change to lowercase & remove spaces for each item in arrays
        pillarTown.map((item) => (item = item.toLowerCase().trim()));
        filterByTownArr.map((item) => (item = item.toLowerCase().trim()));

        // filterByTownArr.forEach((item) => {
        // console.log({item})
        if (
          filterByTownArr.some((pillarItem) => pillarTown.includes(pillarItem))
        ) {
          filterTowns.push(filterByTownArr.value);
        }
        // });
      }
      // If there are any results in filterTowns push this through to countyFilteredResults
      if (filterTowns.length) {
        townFilteredResults.push(pillar._id);
      }
    }
    // console.log('🍞 🍞 🍞 🍞 ', { townFilteredResults });
  };

  // If first array _type is hotel check hotelSearchOptions otherwise it will be a pillar so we check pillarSearchOptions
  // console.log({ hotelsOrPillar });
  if (hotelsOrPillar[0]._type === "hotel") {
    hotelsOrPillar.forEach((hotel) => {
      hotelSearchOptions(hotel);
    });
  } else {
    // console.log('pillar!!!');
    hotelsOrPillar.forEach((pillar) => {
      pageSearchOptions(pillar);
    });
  }

  // THEN....
  // console.log('inside function', { tagFilteredResults });
  // console.log('inside function', {countryFilteredResults});
  // console.log('inside function', {countyFilteredResults});
  // console.log('inside function', {townFilteredResults});
  // if filterByCountyOrTown we combine & remove duplicates
  let countyOrTownFilteredHotels;
  if (filterByCountyOrTown) {
    countyOrTownFilteredHotels = [
      ...new Set([...townFilteredResults, ...countyFilteredResults]),
    ];
    // TODO: then filter all other arrays that have matching ids
  }
  // console.log(countyOrTownFilteredHotels)

  // Now we need to combine the results into allFilteredResults
  const allFilteredArrays = [];

  // Need to check if arrays are empty - are they empty because the sanity field was empty or there were no results?  If it's because there were no results then we need to add that empty array to allFilteredArrays as ultimately the filter fields return no hotels
  // ? TIDY: CONSOLES FOR TESTING REMOVE AND JUST KEEP IF WITHOUT ELSE
  if (filterByTags && tagFilteredResults.length) {
    // console.log('we have search tags!')
    allFilteredArrays.push(tagFilteredResults);
  }

  if (filterByCountry.length && countryFilteredResults.length) {
    // console.log('we have countries!', countryFilteredResults);
    allFilteredArrays.push(countryFilteredResults);
  }

  // if filterByCountyOrTown then we can check if either array exists
  if (filterByCountyOrTown) {
    if (
      (filterByCounty && countyFilteredResults.length) ||
      (filterByTown && townFilteredResults.length)
    ) {
      // console.log('we have counties or towns!');
      allFilteredArrays.push(countyOrTownFilteredHotels);
    }
    // otherwise check separately
  } else {
    if (filterByCounty && countyFilteredResults.length) {
      // console.log('we have counties!', countyFilteredResults);
      allFilteredArrays.push(countyFilteredResults);
    }

    if (filterByTown && townFilteredResults.length) {
      // console.log('we have towns!', townFilteredResults);
      allFilteredArrays.push(townFilteredResults);
    }
  }

  if (allFilteredArrays.length) {
    // Combine all arrays we created from above and reduce to one removing any duplicates
    allFilteredResults = allFilteredArrays.shift().reduce(function (res, v) {
      if (
        res.indexOf(v) === -1 &&
        allFilteredArrays.every(function (a) {
          return a.indexOf(v) !== -1;
        })
      )
        res.push(v);
      return res;
    }, []);
  }

  return allFilteredResults;
};

export { getHotelsBySearchTags };
